import React from 'react';
import PropTypes from 'prop-types';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { TextField } from '@totalsoft/rocket-ui';

const MultilineEditor = ({
  formulaLabel,
  formulaPropertyName,
  formulaPropertyValue,
  isReadOnly,
  onPropertyChanged,
  validation,
  ...rest
}) => {
  return (
    <TextField
      multiline
      maxRows='5'
      disabled={isReadOnly || false}
      fullWidth
      value={formulaPropertyValue}
      name={formulaPropertyName}
      onChange={value => onPropertyChanged(formulaPropertyName, value)}
      label={formulaLabel}
      error={validation && !isValid(validation)}
      helperText={validation && getErrors(validation)}
      {...rest}
    />
  );
};
MultilineEditor.propTypes = {
  formulaLabel: PropTypes.string.isRequired,
  formulaPropertyName: PropTypes.string.isRequired,
  formulaPropertyValue: PropTypes.string.isRequired,
  isReadOnly: PropTypes.bool,
  validation: PropTypes.object,
  onPropertyChanged: PropTypes.func.isRequired
};
export default MultilineEditor;
